import { Box, Typography, Radio } from "@mui/material";
import { getImageURL } from "./relationImageUtils";
import { handleKeyboardClick } from "../../../utils/keyboardUtils";
  
const BeneficiaryCard = ({ beneficiary, selected, onSelect, hasSelection = false }) => {
  const imageURL = getImageURL(beneficiary.relationName, beneficiary.gender);

  return (
    <Box
      onClick={() => onSelect(beneficiary)}
      role="radio"
      aria-checked={selected}
      aria-label={`${beneficiary.name}, ${beneficiary.relationName}${selected ? ", selected" : ", not selected"}`}
      aria-hidden={hasSelection && !selected ? "true" : undefined}
      aria-posinset={-1}
      aria-setsize={-1}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "16px",
        borderRadius: "12px",
        border: selected ? "1.5px solid #0066DC" : "1px solid #d2d8e0",
        backgroundColor: "#fff",
        cursor: "pointer",
        position: "relative",
        minWidth: { xs: "280px", md: "auto" },
        "&:focus": {
          outline: "none",
          border: selected ? "2px solid #0066DC" : "2px solid #47566A",
        }
      }}
      tabIndex={hasSelection && !selected ? -1 : 0}
      onKeyDown={handleKeyboardClick(() => onSelect(beneficiary))}
    >
      <Box
        component="img"
        src={imageURL}
        alt={beneficiary.name}
        aria-hidden="true"
        sx={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          objectFit: "cover",
          flexShrink: 0,
        }}
        onError={(e) => {
          e.target.src = `https://views.medibuddy.in/mb-web/public/${
            beneficiary.gender === "M" ? "male.svg" : "female.svg"
          }`;
        }}
      />

      <Box aria-hidden="true" sx={{ flex: 1, overflow: "hidden" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#252D38",
            lineHeight: "22px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {beneficiary.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 300,
            color: "#47566A",
            lineHeight: "20px",
          }}
        >
          {beneficiary.relationName}
        </Typography>
      </Box>

      <Radio
        aria-hidden="true"
        tabIndex={-1}
        checked={selected}
        sx={{
          color: "#252D38",
          "&.Mui-checked": {
            color: "#0066DC",
          },
          padding: "8px",
        }}
      />
    </Box>
  );
};

export default BeneficiaryCard;